import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  CardText,
} from "reactstrap";
const SouscriptionsCard = ({ title, details }) => {
  return (
    <Card className="mb-4">
      <CardTitle tag="h5" style={{ paddingLeft: 10 }}>
        {title}
      </CardTitle>
      <CardBody>
        {details ? (
          Object.entries(details).map(([key, value], index) => (
            <Row key={index} className="mb-3">
              <Col className="col-4" style={{ whiteSpace: "nowrap" }}>
                <i style={{ color: "#9d9c9c" }}>
                  <span
                    style={{
                      display: "inline-block",
                      width: "8em",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {key} :
                  </span>
                </i>
              </Col>
              <Col className="col-8" style={{ textAlign: "right" }}>
                <span
                  style={{
                    paddingInlineStart: "8em",
                    whiteSpace: "pretty",
                    fontFamily: "sans-serif",
                  }}
                >
                  {key.includes("€") ? (
                    renderValue(value).toLocaleString("fr-FR", {
                      style: "currency",
                      currency: "EUR",
                    })
                  ) : key.includes("%") ? (
                    renderValue(value).toLocaleString("fr-FR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    }) + " %"
                  ) : key == "Fichier" ? (
                    <a href={value} download>
                      <i
                        style={{
                          fontSize: "25px",
                          paddingLeft: "8px",
                          textalign: "center",
                          verticalalign: "middle",
                        }}
                        className="bx bx-download"
                      ></i>
                    </a>
                  ) : (
                    renderValue(value)
                  )}
                  {}
                </span>
              </Col>
            </Row>
          ))
        ) : (
          <></>
        )}
      </CardBody>
    </Card>
  );
};

const renderValue = (value) => {
  if (value == null) {
    return "";
  } else if (typeof value === "string" && value.trim() === "") {
    return "";
  } else if (value === "Validé") {
    return <span className="bg-success badge bg-secondary">{value}</span>;
  } else if (value === "En attente") {
    return <span className="bg-info badge bg-secondary">{value}</span>;
  } else {
    return value;
  }
};
export default SouscriptionsCard;
